import { useChainId, useConfig, useSwitchChain } from "wagmi";
import { getChainId } from "@wagmi/core";
import { base } from "wagmi/chains";

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

function normalizeChainId(value) {
  if (value == null) return null;

  // number -> number
  if (typeof value === "number") return value;

  // string -> number (supports "0x..." or "8453")
  if (typeof value === "string") {
    const v = value.trim().toLowerCase();
    if (v.startsWith("0x")) return parseInt(v, 16);
    if (/^\d+$/.test(v)) return parseInt(v, 10);
  }

  return null;
}

export function useEnsureBase() {
  const chainId = useChainId();        // reactive UI
  const config = useConfig();          // wagmi config
  const { switchChainAsync } = useSwitchChain();

  const ensureBase = async () => {
    const current = getChainId(config);
    if (current === base.id) return true;

    try {
      await switchChainAsync({ chainId: base.id });
    } catch (e) {
      // user rejected switch
      if (e?.code === 4001 || String(e?.message || "").toLowerCase().includes("user rejected"))
        return false;
      throw e;
    }

    // wait until wagmi reflects the new chain
    for (let i = 0; i < 25; i++) {
      await sleep(120);
      const after = getChainId(config);
      if (after === base.id) return true;

      // fallback: also accept window.ethereum if it’s updated
      const eth = window?.ethereum;
      const ethId = normalizeChainId(eth?.chainId);
      if (ethId === base.id) return true;
    }

    return false;
  };

  return {
    isBase: chainId === base.id,
    ensureBase,
  };
}
